import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUiComponent } from '../utils/uiComponentTracker';

const routeLabels: Array<{ pattern: RegExp; name: string }> = [
  { pattern: /^\/formular\/[^/]+$/, name: 'PublicFormularPage' },
  { pattern: /^\/public\/form\/[^/]+$/, name: 'PublicFormularPage' },
  { pattern: /^\/native-login$/, name: 'NativeLogin' },
  { pattern: /^\/login$/, name: 'Login' },
  { pattern: /^\/$/, name: 'Dashboard' },
  { pattern: /^\/tasks$/, name: 'Tasks' },
  { pattern: /^\/tickets$/, name: 'TicketsPage' },
  { pattern: /^\/stores$/, name: 'Stores' },
  { pattern: /^\/users$/, name: 'Users' },
  { pattern: /^\/hausmeister$/, name: 'HausmeisterDienstPage' },
  { pattern: /^\/settings$/, name: 'Settings' },
  { pattern: /^\/settings\/secondary-placement-reports$/, name: 'SecondaryPlacementReportsPage' },
  { pattern: /^\/katalog$/, name: 'KatalogPage' },
  { pattern: /^\/verlauf$/, name: 'Archiv' },
  { pattern: /^\/archiv$/, name: 'Archiv' },
  { pattern: /^\/completed-today$/, name: 'Archiv' },
  { pattern: /^\/export$/, name: 'Export' },
  { pattern: /^\/rolli$/, name: 'RolliPage' },
  { pattern: /^\/layoutbaustein$/, name: 'LayoutBausteinPage' },
  { pattern: /^\/planner$/, name: 'Planner' },
  { pattern: /^\/kampagnen$/, name: 'KampangenPage' },
  { pattern: /^\/mitteilungen$/, name: 'TickerPage' },
  { pattern: /^\/nachweise$/, name: 'NachweisePage' },
  { pattern: /^\/bildpool$/, name: 'ImagePoolPage' },
  { pattern: /^\/zeiterfassung$/, name: 'ZeiterfassungPage' },
  { pattern: /^\/zeiterfassung-analyse$/, name: 'ZeiterfassungAnalysePage' },
  { pattern: /^\/revisions\/auswertung$/, name: 'RevisionAnalyticsPage' },
  { pattern: /^\/reinigung$/, name: 'ReinigungsPage' },
  { pattern: /^\/reinigung\/uebersicht$/, name: 'ReinigungsUebersichtPage' },
  { pattern: /^\/reinigung\/auswertung$/, name: 'ReinigungBeanstandungReportPage' },
  { pattern: /^\/client-status$/, name: 'ClientStatus' },
  { pattern: /^\/revisions\/admin$/, name: 'RevisionDefinitionsPage' },
  { pattern: /^\/admin-system$/, name: 'AdminSystem' },
  { pattern: /^\/einstellungen\/formular-templates$/, name: 'FormularTemplatesPage' },
  { pattern: /^\/einstellungen\/formular-templates\/neu$/, name: 'FormularTemplateUploadPage' },
  { pattern: /^\/einstellungen\/formular-templates\/[^/]+\/editor$/, name: 'FormularTemplateEditorPage' },
  { pattern: /^\/einstellungen\/rolli-zeitvorgaben$/, name: 'RolliTimeEstimatesAdminPage' },
  { pattern: /^\/formular-uebersicht$/, name: 'StoreFormularUebersichtPage' },
];

const normalizePath = (pathname: string) => (pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname);

const resolveRouteLabel = (pathname: string) => {
  const normalized = normalizePath(pathname);
  const match = routeLabels.find(({ pattern }) => pattern.test(normalized));
  return match?.name ?? `Route:${normalized || '/'}`;
};

export default function UiRouteTracker() {
  const location = useLocation();
  const routeLabel = useMemo(() => resolveRouteLabel(location.pathname), [location.pathname]);

  useUiComponent(routeLabel, 'page');
  return null;
}
